// Runs an Association delete; if the server says it is still billing in Stripe,
// asks the user to confirm cancelling billing, then retries with cancelBilling=true.
// Returns false if the user declined.
export async function withBillingAck(run) {
  try {
    await run(false);
    return true;
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status !== 409 || d?.code !== "billing_active") throw e;
    if (!window.confirm(d.message)) return false;
    await run(true);
    return true;
  }
}

// After restoring an Association whose subscription was cancelled, offer a new invite.
export async function offerResubscribe(axios, API, aid, assocName, data) {
  if (!data?.resubscribe_email) return;
  const msg = `${assocName || "This association"} has no active subscription. Send ${data.resubscribe_email} `
    + `a new subscription invite (${data.resubscribe_plan} plan) so billing can restart?`;
  if (!window.confirm(msg)) return;
  await axios.post(`${API}/admin/subscription-invites`, {
    kind: "existing", association_id: aid, email: data.resubscribe_email,
    full_name: data.resubscribe_name || null, plan: data.resubscribe_plan,
  });
  window.alert(`Subscription invite sent to ${data.resubscribe_email}.`);
}

// Server error detail may be a string or { message }.
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return (d && (d.message || (typeof d === "string" ? d : null))) || e?.message || "Failed.";
};
